import { produce } from "immer";
import * as entityActions from "./entityActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";
import { idEncode } from "utils/idFixer";

const initialState = {
  start: null,
  end: null,
  loaded: [],
  byId: {},
  allIds: []
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case entityActions.FETCH_EVENTS_SUCCESS: {
      const { start, end, events } = action.payload;
      draft.loaded.push({
        start,
        end
      });
      draft.start = start;
      draft.end = end;

      let eventIds = [];
      let eventIdsR = [];
      let i = 1;
      events.forEach(message =>
        message?.instances?.forEach(element => {
          let id = element.id;
          if (eventIds.findIndex(item => item === id) > -1) {
            eventIdsR.push(element.id);
            id = idEncode(element.id, i);
            i++;
          }
          eventIds.push(id);
        })
      );
      eventIdsR = [...new Set(eventIdsR)];
      eventIdsR.forEach(id => {
        const index = eventIds.findIndex(item => item === id);
        if (index > -1) eventIds.splice(index, 1, idEncode(id, 0));
      });

      let byId = {};
      i = 1;
      events.forEach(message => {
        message?.instances?.forEach(element => {
          let id = element.id;
          if (!!byId[id]) {
            id = idEncode(element.id, i);
            i++;
          }
          byId[id] = {
            ...element,
            id,
            recurring: message.recurring,
            tags: message.tags,
            user_id: message.user_id,
            calendar_id: message.calendar_id ?? message.folder_id
          };
        });
      }, {});
      eventIdsR.forEach(id => {
        const item = byId[id];
        delete byId[id];
        byId[idEncode(id, 0)] = { ...item, id: idEncode(id, 0) };
      });

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });

      draft.allIds = deepmerge(draft.allIds, eventIds, {
        arrayMerge: combineMerge
      });

      break;
    }

    case entityActions.CREATE_EVENT: {
      const { payload } = action;
      const { id } = payload;

      draft.byId[id] = {
        ...payload
      };

      draft.allIds.push(payload.id);
      break;
    }

    case entityActions.UPDATE_EVENT: {
      const { payload } = action;
      const { id, data } = payload;

      const name = data.name;
      delete data.name;
      draft.byId[id] = {
        ...draft.byId[id],
        ...data,
        name
      };
      break;
    }

    case entityActions.UPDATE_EVENT_IF_EXISTS: {
      const { payload } = action;
      const { id, data } = payload;

      if (!draft.byId[id]) {
        return;
      }

      const name = data.name;
      delete data.name;
      draft.byId[id] = {
        ...draft.byId[id],
        ...data,
        name
      };
      break;
    }

    case entityActions.DELETE_EVENT: {
      const { payload } = action;
      draft.byId[payload].status = "deleted";
      break;
    }

    case entityActions.CREATE_EVENT_IF_NOT_EXISTS: {
      const { payload } = action;
      const { id } = payload;

      const isExist = draft.byId[id];

      draft.byId[id] = {
        ...payload
      };

      !isExist && draft.allIds.push(payload.id);
      break;
    }

    case entityActions.DELETE_EVENT_IF_EXISTS: {
      const { payload } = action;
      if (draft.byId[payload]?.status === "deleted" || !draft.byId[payload]) {
        return;
      }

      draft.byId[payload].status = "deleted";
      break;
    }

    case entityActions.RESET: {
      return initialState;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
